import React from 'react';
import { cn } from '@/lib/utils';

const CorrelationColorLegend: React.FC<React.PropsWithChildren<{ fontSize?: string }>> = ({ fontSize }) => {
  return (
    <div
      className={cn([fontSize ? 'w-[25em] ml-[1.4em] mt-[0.6em]' : 'w-[280px] ml-[20px] mt-2.5'])}
      style={fontSize ? { fontSize } : undefined}
    >
      <div className={cn(['w-full bg-venn-diverging', fontSize ? 'h-[1.2em]' : 'h-[14px]'])} />
      <div className="mt-0.5 flex justify-between">
        <span>-1.0</span>
        <span>0</span>
        <span>+1.0</span>
      </div>
    </div>
  );
};

export default CorrelationColorLegend;
